export default class Events {
    constructor() {
        this.init();
    }

    init() {
        $('form.event-list-filters').submit(() => {
            window.showLoader();
        });

        $('#events-list').on('click', '.load-more', () => {
            window.showLoader();
        });

        $('#events-list').on('click', 'button[data-request="onReinitFilters"]', () => {
            window.showLoader();
        });
    }

}
